import styles from "./FilterPrice.module.css"
import React, { useEffect, useState, useRef } from 'react';
import { useFilterContext } from "../../../../context/FilterContext";
/**
* Props for the FilterPrice component.
*/ 
interface PriceFilterProps {
    min: number; // Minimal price
    max: number; // Maximal price
    setPrice: (min: number, max: number) => void // Set price handler,
    menuOpen: boolean
}
/**
* A price filter component with adjustable range.
*
* @param props FilterPrice props
* @param {number} props.min - Minimal price
* @param {number} props.max - Maximal price
* @param {(min: number, max: number) => void} props.setPrice - Set price handler
* @returns TSX.Element
*/
const FilterPrice = ({min, max, setPrice, menuOpen} : PriceFilterProps) => {
    const {filterData } = useFilterContext(); // Filter data
    // Initial maximum and minimun values
    const [sliderMinValue] = useState(min);
    const [sliderMaxValue] = useState(max);

    const getCurrentFilterMin = () => filterData?.cena && filterData.cena.length > 0 ? filterData.cena[0] : min;
    const getCurrentFilterMax = () => filterData?.cena && filterData.cena.length > 1 ? filterData.cena[1] : max;
    
    // Current maximum and minimum value
    const [minVal, setMinVal] = useState(getCurrentFilterMin());
    const [maxVal, setMaxVal] = useState(getCurrentFilterMax());

    // Reset price on closing without submit
    useEffect(() => {
        if (menuOpen === false) {
            // Reset to current filter values, not to initial min/max
            setMinVal(getCurrentFilterMin());
            setMaxVal(getCurrentFilterMax());
        }
    }, [menuOpen, filterData.cena]);

    // Range ref
    const range = useRef<HTMLDivElement | null>(null)
    const minGap = 5;
    // Make sure to set sliders correctly on filter change
    useEffect(() => {
        setMinVal(getCurrentFilterMin());
        setMaxVal(getCurrentFilterMax());
    }, [filterData.cena])

    useEffect(() => {
        setSliderTrack();
        setPrice(minVal, maxVal);
    }, [minVal, maxVal]);

    // Handle change of minimum value
    const slideMin = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = parseInt((e.target as HTMLInputElement).value, 10);
        if (value >= sliderMinValue && maxVal - value >= minGap) {
        setMinVal(value);
        }
    };
    // Handle change of maximum value
    const slideMax = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = parseInt((e.target as HTMLInputElement).value, 10);
        if (value <= sliderMaxValue && value - minVal >= minGap) {
            setMaxVal(value);
        }
    };
    // Handle resizing the slider
    const setSliderTrack = () => {
        if (range.current) {
            const minPercent =
                ((minVal - sliderMinValue) / (sliderMaxValue - sliderMinValue)) * 100;
            const maxPercent =
                ((maxVal - sliderMinValue) / (sliderMaxValue - sliderMinValue)) * 100;
            range.current.style.left = `${minPercent}%`;
            range.current.style.right = `${100 - maxPercent}%`;
        }
    }

    return(
        <>
            <div className={styles.Price}>
                <div className={styles.PricePicker}>
                    <div className={styles.rangeSlider}>
                        <div className={styles.sliderTrack} ref={range}>
                            <span className={`${styles.LeftTooltip} ${styles.Tooltip}`} >{minVal} Kč</span>
                            <span className={`${styles.RightTooltip} ${styles.Tooltip}`} >{maxVal} Kč</span>
                        </div>
                        <input
                        type="range"
                        min={sliderMinValue}
                        max={sliderMaxValue}
                        value={minVal}
                        onChange={slideMin}
                        />
                        <input
                        type="range"
                        min={sliderMinValue}
                        max={sliderMaxValue}
                        value={maxVal}
                        onChange={slideMax}
                        />
                        
                    </div>
                </div>
                <div className={styles.PriceLabels}>
                    <p>{minVal} Kč</p>
                    <p>{maxVal} Kč</p>
                </div>
            </div>
        </>
    )
};
export default FilterPrice;